import { getBridgeSdk } from "@swiggy-private/checkout-core";
import { captureError } from "@swiggy-private/core-ui";
import { CLEVERTAP_KEYS } from "@dineout-cart-client/constants/Constants";

interface IDealCartEventProps {
    payableAmount?: string;
    rxID?: string;
    dealDetail?: {
        reservationTime?: string;
        groupName?: string;
        dealTitle?: string;
        dealId?: string;
        count?: number;
        variantId?: string;
    };
    rxLocality?: string;
    city?: string;
    eventId?: string;
    ticketId?: string;
}

export const logDealCartEvent = (eventProps: IDealCartEventProps): void => {
    try {
        const commonEventProps = {
            payableAmount: eventProps.payableAmount ?? "0",
            rxID: eventProps.rxID ?? "",
            dealDetail: {
                reservationTime: eventProps.dealDetail?.reservationTime,
                groupName: eventProps.dealDetail?.groupName,
                dealTitle: eventProps.dealDetail?.dealTitle,
                dealId: eventProps.dealDetail?.dealId,
                count: eventProps.dealDetail?.count,
                variantId: eventProps.dealDetail?.variantId,
            },
            rxLocality: eventProps.rxLocality ?? "",
            city: eventProps.city,
            eventId: eventProps.eventId,
            ticketId: eventProps.ticketId,
        };

        getBridgeSdk().logClevertapEvent({
            eventName: CLEVERTAP_KEYS.DINERS_AF_DEAL_ADD_TO_CART,
            params: commonEventProps,
        });
    } catch (error) {
        captureError(error);
    }
};
